export const SOFTWARE_PAGE_VIEWED_COOKIE = '_solidshop_software_page_viewed';
